/** Shared constants: WS path, heartbeat interval, protocol version. */

export const PROTOCOL_VERSION = 1 as const;

/** The single data channel of the application. */
export const WS_PATH = '/ws';

/** Server sends a ping this often; client force-reconnects if nothing arrives. */
export const HEARTBEAT_SECONDS = 25;
export const CLIENT_SILENCE_TIMEOUT_SECONDS = 40;
export const SERVER_PONG_TIMEOUT_SECONDS = 60;

/** Request timeout on the client side, milliseconds. */
export const REQUEST_TIMEOUT_MS = 15_000;

/** Reconnect backoff, milliseconds. */
export const RECONNECT_MIN_MS = 1_000;
export const RECONNECT_MAX_MS = 30_000;

/** Element id carrying the SSR state that the client hydrates from. */
export const SSR_STATE_ELEMENT_ID = '__STATE__';

/** Signature payload prefix. Bump it if the signed string layout ever changes. */
export const SIGNATURE_PREFIX = 'EBK1';

/** Credential document format written by `bun run issue-key`. */
export const CREDENTIAL_FORMAT = 'ebk-credential/1';

/** WebCrypto parameters of the owner key. */
export const KEY_ALGORITHM = { name: 'ECDSA', namedCurve: 'P-256' } as const;
export const SIGN_ALGORITHM = { name: 'ECDSA', hash: 'SHA-256' } as const;
export const KEY_ALG_LABEL = 'ECDSA-P256-SHA256';

/** IndexedDB where the owner keys live. */
export const IDB_NAME = 'ebk';
export const IDB_STORE = 'keys';
export const IDB_VERSION = 1;

/** localStorage flag: the owner pressed "Выход" and must not be let back in
 *  automatically. Survives a reload, which is the whole point of a logout. */
export const SIGNED_OUT_FLAG = 'ebk.signedOut';

/**
 * Marks that the owner has already entered in this browser, so a page reload
 * continues the session instead of starting a new ceremony. Written to
 * localStorage or sessionStorage depending on how the key is protected - see
 * key-store.ts for which and why.
 */
export const ENTERED_FLAG = 'ebk.entered';

/** WebAuthn relying-party name shown in the Windows Hello / Touch ID prompt. */
export const WEBAUTHN_RP_NAME = 'Консоль резервного копирования';

/** Cookie used ONLY to personalise the first SSR document. Never authenticates the socket. */
export const SSR_COOKIE = 'ebk_ssr';
